// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"5c28f03e","810":"795edd5e"}[chunkId] + ".chunk.css";
};